export default "__VITE_ASSET__vkA6vYb6__"